import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

const ApplyjobAsInstitute = ({ jobId, isAppliedByYou, instituteAppliedJobsInfo, status, getJobDetail }) => {
	const sessionId = localStorage.getItem("sessionId");
	console.log("sessionId", sessionId);
	console.log("Institution Applied Job===>", isAppliedByYou)
	// // ..................................Apply Institute Modal...................................
	const [applyInstitute, setApplyInstitute] = useState(false);
	const handleApplyInstitute = () => setApplyInstitute(true);
	const handleCloseApplyInstitute = () => setApplyInstitute(false);
	// // .................................Apply Institute Modal...................................

	const [batchId, setBatchId] = useState(null);
	const [ClassId, setClassId] = useState(null);

	const [batchList, setBatchList] = useState([]);
	const [ClassList, setClassList] = useState([]);

	const [selectedType, setSelectedType] = useState("");
	const [checkApplied, setCheckApplied] = useState(isAppliedByYou);

	const [showAppliedModal, setShowAppliedModal] = useState(false);
	const handleShow = () => setShowAppliedModal(true);
	const handleCloseModal = () => setShowAppliedModal(false);
	console.log("selectedType", selectedType);

	const classIDs = instituteAppliedJobsInfo?.classIDs || [];
	const batchIDs = instituteAppliedJobsInfo?.batchIDs || [];

	const [isLoading, setIsLoading] = useState(false);

	const handleApplyJob = async () => {

		setIsLoading(true);
		try {
			const response = await axios.post(`/JobAction/ApplyJobAsInstt`, {
				sessionId: sessionId,
				jobId: jobId,
				icsid: ClassId,
				icbid: batchId,
			});

			console.log("API Response:", response);
			toast.success("Job applied successfully!");
			setCheckApplied(true);
			handleCloseApplyInstitute()
			getJobDetail()

		} catch (error) {
			console.error("Error applying for job:", error);
			toast.error(error.response.data.message);
			setApplyInstitute(false);
		} finally {
			setApplyInstitute(false)
			setIsLoading(false); // Hide loader after request is completed
		}
	};

	// Unapply job by Institute
	const UnApplyJobInstitute = async () => {
		console.log("unapply inst clicked");

		try {
			const response = await axios.post(`/JobAction/UnApplyJobAsInstt`, {
				sessionId: sessionId,
				jobId: jobId,
				icsid: ClassId,
				icbid: batchId,
			});
			console.log("UnApplyJob", response);
			toast.success(response.data.message);
			setShowAppliedModal(false);
			setCheckApplied(false);
			getJobDetail()

		} catch (error) {
			console.error("Error applying for job:", error);
			toast.error(error.response?.data?.message);
			setShowAppliedModal(false);


		} finally {
			setShowAppliedModal(false);
		}
	};

	// // ..............................................................................................................

	const handleBatch = (val) => {
		console.log("handle batch", val.value);
		if (val) {
			setBatchId(val.value);
		} else {
			setBatchId(null);
		}
	};
	const handleClass = (val) => {
		if (val) {
			setClassId(val.value);
		} else {
			setClassId(null);
		}
	};

	console.log("Batch List:", batchList);
	console.log("Class List:", ClassList);

	// ........................... Class API
	const GetCandidateClass = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Class",
		};

		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Class data details page", response);
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setClassList(data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	// ........................... BATCH API
	const GetCandidateBatch = () => {
		console.log("=========>");

		const data = {
			sessionId: sessionId,
			name: "",
			type: "Batch",
		};
		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Batch data=====>", response.data.responseData);
				const res = response.data.responseData;
				console.log("res", res);

				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				console.log("data===>", data);

				setBatchList(data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		if (applyInstitute) {
			GetCandidateClass();
			GetCandidateBatch();
		}
	}, []);

	const [viewApplyList, setViewApplyList] = useState(false);
	const openModal = () => setViewApplyList(true);
	const closeModal = () => setViewApplyList(false);

	// ....................................................
	// ....................................................
	const [formValid, setFormValid] = useState(false);


	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Updated values
		const updatedSelectedType = fieldName === "selectedType" ? value : selectedType;
		const updatedBatch = fieldName === "batch" ? value : batchIDs;
		const updatedClass = fieldName === "class" ? value : classIDs;

		// Check if required fields are filled
		const isValid =
			updatedSelectedType !== "Select Type" &&
			((updatedSelectedType === "Batch" && updatedBatch) ||
				(updatedSelectedType === "Class" && updatedClass));

		setFormValid(isValid);
	};

	// ....................................................
	// ....................................................


	return (
		<>
			{status === 1 ? (
				<>
					{checkApplied === true ? (
						<div className="appliedbtn mb-1">
							<Button
								className=" InsApplybtn mainBtn  appliedBtn apply-job"
								style={{ width: "100px" }}
								onClick={() => {
									handleShow();
								}}
							>
								<span className="default-text">Applied</span>
								<span className="hover-text">Withdraw</span>
							</Button>
						</div>
					) : (
						<>
							{instituteAppliedJobsInfo === null ? '' : (
								<Button className="mainBtn eye-icon-color me-2"
									onClick={openModal}>
									<VisibilitySharpIcon
										style={{ cursor: "pointer" }}
										className="joblist-eye-icon locationIcon"
									/>
								</Button>
							)}

							{/* <Button className="mainBtn eye-icon-color me-2"
						onClick={openModal}>
						<VisibilitySharpIcon
							style={{ cursor: "pointer" }}
							className="joblist-eye-icon locationIcon"
						/>
					</Button> */}
							<Button
								className="mainBtn apply-job apply-job-button"
								onClick={() => {
									handleApplyInstitute();
									GetCandidateClass();
									GetCandidateBatch()
								}}
							>
								Apply Now
							</Button>
						</>

					)}
				</>
			) :
				(
					<Button className="mainBtn red">
						Job Is InActive
					</Button>
				)
			}

			{/*................................ Apply Institute Modal Start ...............................*/}
			<Modal show={applyInstitute} onHide={handleCloseApplyInstitute}>
				<Modal.Header closeButton>
					<Modal.Title>Apply for the Job</Modal.Title>
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						<Col md={12}>
							<Form.Group controlId="Name_Title">
								<Form.Label className="class-type">
									Type
									<span style={{ color: "red" }} className=""> *</span>
								</Form.Label>
							</Form.Group>
							<div className="post-form-group">
								<Form.Group controlId="batchDropdown">
									<Form.Control
										as="select"
										defaultValue="Select Type"
										// onChange={(e) => {setSelectedType(e.target.value);}}
										onChange={(e) => handleFieldChange(setSelectedType, e.target.value, "selectedType")}
										placeholder="Select Type"
										className="Dark-Input-from-group"
									>
										<option disabled>Select Type</option>
										<option value="Batch">Batch</option>
										<option value="Class">Class</option>
									</Form.Control>
								</Form.Group>
							</div>

						</Col>
					</Row>
					<div className="post-form-row">
						{selectedType === "Batch" && (
							<Col md={12}>
								<div className="post-form-group">
									<label htmlFor="type">Batch</label>
									<ReactSelect
										options={batchList}
										// onChange={handleBatch}
										onChange={(option) => handleFieldChange(setBatchId, option ? option.value : "", "batch")}
										placeholder="Select Batch"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
								</div>
							</Col>
						)}
						{selectedType === "Class" && (
							<Col md={12}>
								<div className="post-form-group">
									<label htmlFor="type">Class</label>
									<ReactSelect
										options={ClassList}
										// onChange={handleClass}
										onChange={(option) => handleFieldChange(setClassId, option ? option.value : "", "class")}
										placeholder="Select Class"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
								</div>
							</Col>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseApplyInstitute}>
						Close
					</Button>
					{/* <Button
						className="apply-job"
						variant="primary"
						onClick={handleApplyJob}
						disabled={isLoading}
					>
						{isLoading ? "Submitting..." : "Submit"}
					</Button> */}
					<Button
						className="apply-job"
						variant="primary"
						onClick={handleApplyJob}
						disabled={!formValid || isLoading}
					>
						{isLoading ? "Submitting..." : "Submit"}
					</Button>
				</Modal.Footer>
			</Modal>
			{/*.................................. Apply Institute Modal End ..................................*/}

			{/*.................................... UnApply Job Modal Start ................................*/}

			<Modal show={showAppliedModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title> UnApply job</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to Unapply job</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						onClick={

							UnApplyJobInstitute
						}
						className="btn btn-danger me-2"
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>
			{/*.................................... UnApply Job Modal End ................................*/}


			<Modal show={viewApplyList} onHide={closeModal}>
				<Modal.Header >
					<Modal.Title>View Applied Classes</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={closeModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					{classIDs.length === 0 ?
						""
						: (
							<>
								<div className="classlist">
									<h4>Classes</h4>
									<ul>
										{classIDs.map((id, index) => (
											<li key={id} className="d-flex justify-content-between align-item-center">
												<div className="name">
													{instituteAppliedJobsInfo?.classNames[index]}
												</div>
												<div className="appliedbtn mb-2">
													<Button
														className="InsApplybtn mainBtn  appliedBtn  apply-job  mt-0"
														style={{
															width: "100px"
														}}
														onClick={() => {
															handleShow();
															setClassId(instituteAppliedJobsInfo.classIDs[0].toString())

														}}
													>
														<span className="default-text">Applied</span>
														<span className="hover-text">Withdraw</span>
													</Button>
												</div>
											</li>
										))}
									</ul>
								</div>
							</>
						)}
					{batchIDs.length === 0 ?
						""
						: (
							<>
								<div className="batchlist">
									<h4>Batches</h4>
									<ul>
										{batchIDs.map((id, index) => (
											<li key={id} className="d-flex justify-content-between align-item-center">
												<div className="name">
													{instituteAppliedJobsInfo?.batchNames[index]}
												</div>
												<div className="appliedbtn mb-1">
													<Button
														className="InsApplybtn mainBtn  appliedBtn apply-job  mt-0"
														style={{ width: "100px" }}
														onClick={() => {
															handleShow();
															setBatchId(instituteAppliedJobsInfo.batchIDs[0].toString())

														}}
													>
														<span className="default-text">Applied</span>
														<span className="hover-text">Withdraw</span>
													</Button>
												</div>
											</li>
										))}
									</ul>
								</div>
							</>
						)}
				</Modal.Body>


			</Modal>
		</>
	);
};

export default ApplyjobAsInstitute;
